import React from 'react'
import {Button} from 'components'
import styled from 'styled-components'

const DisabledButton = styled(Button)`
  opacity: 0.5;
`


export default DisabledButton